import { Component, type ReactNode } from "react";

/** Aucune actualisation automatique : elle pourrait effacer une saisie. */
export class RouteErrorBoundary extends Component<
  { children: ReactNode },
  { failed: boolean }
> {
  override state = { failed: false };

  static getDerivedStateFromError(): { failed: boolean } {
    return { failed: true };
  }

  override render(): ReactNode {
    if (!this.state.failed) return this.props.children;
    return (
      <section className="content-page" role="alert">
        <h1>Impossible d’afficher cette page</h1>
        <p>
          Une mise à jour ou un problème de connexion peut avoir interrompu son
          chargement.
        </p>
        <p>
          Les données enregistrées sont conservées. Une actualisation peut
          perdre les modifications non enregistrées.
        </p>
        <button
          className="primary-button"
          onClick={() => window.location.reload()}
        >
          Actualiser la page
        </button>
      </section>
    );
  }
}
